editConfirmTextController.$inject = [
                                         '$scope',
                                         '$mdDialog',
                                         'elementData',
                                         'elementView'];
export function editConfirmTextController(
                                              $scope,
                                              $mdDialog,
                                              elementData,
                                              elementView) {
  $scope.ok = submit;
  $scope.cancel = cancel;
  $scope.elementData = elementData;
  $scope.elementView = elementView;

  function submit() {
    $mdDialog.hide({ type: 'ok', data: $scope.elementData });
  }

  function cancel() {
    $mdDialog.cancel();
  }

}
